import { render, staticRenderFns } from "./item.vue?vue&type=template&id=89bf89ae&scoped=true"
import script from "./item.vue?vue&type=script&lang=js"
export * from "./item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89bf89ae",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/mse/texting-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('89bf89ae')) {
      api.createRecord('89bf89ae', component.options)
    } else {
      api.reload('89bf89ae', component.options)
    }
    module.hot.accept("./item.vue?vue&type=template&id=89bf89ae&scoped=true", function () {
      api.rerender('89bf89ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/chat/events/item.vue"
export default component.exports